import { Field, type FieldProps } from 'formik';
import Box from '@common/components/Box';
import ErrorMessage from '@common/components/Messages/ErrorMessage';
import Translated from '@common/components/Translated';

interface GeneralErrorProps {
  error: string;
  submitCount: number;
}

function GeneralError({ submitCount, error }: Readonly<GeneralErrorProps>) {
  return (
    <Field name="required">
      {({ meta }: FieldProps) => {
        if (submitCount > 0 && (meta.error || error)) {
          return (
            <Box mb={2}>
              <ErrorMessage>
                <Translated
                  id={
                    meta.error
                    || error /* NOSONAR:S6606 - Intentional: empty string should trigger fallback */
                  }
                />
              </ErrorMessage>
            </Box>
          );
        }

        return null;
      }}
    </Field>
  );
}

export default GeneralError;
